const ModuleCardDescription = ({ descriptionText }) => {
    if (!descriptionText) return <div style={{ flex: 1 }} />;

    return (
        <p
            className="fs12px fw400 c15 op70 m0 h100 df aife"
            style={{
                WebkitLineClamp: 2,
                WebkitBoxOrient: 'vertical',
                overflow: 'hidden'
            }}
        >
            {descriptionText}
        </p>
    );
};

export default ModuleCardDescription;
